export default [
    '$state',
    function ($state) {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                distributionListReceiver: '=eeeDistributionListReceiver',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.click = () => {
                        $state.go('messenger.home.conversation', {
                            type: 'distributionList',
                            id: this.distributionListReceiver.id,
                            initParams: null,
                        });
                    };
                }],
            template: `
                <div class="distribution-list-badge receiver-badge" ng-click="ctrl.click()">
                    <section class="avatar-box">
                        <eee-avatar eee-receiver="ctrl.distributionListReceiver"
                                    eee-resolution="'low'"></eee-avatar>
                    </section>
                    <div class="receiver-badge-name"
                        ng-bind-html="ctrl.distributionListReceiver.displayName | escapeHtml | emojify">
                    </div>

                </div>
            `,
        };
    },
];
